// El catálogo del contador en la cotización, según la MODALIDAD (B1, docs/cd2b-importar-catalogo).
//
// La pregunta «¿el cliente trae el catálogo de su contador?» —y su archivo— solo sirve en la
// modalidad `nube`: es la única en la que el api crea la empresa (`crearEmpresaDemo` rechaza
// cualquier otra con MODALIDAD_NO_NUBE) y, por tanto, la única en la que `exigirCatalogoEntendido`
// llega a correr y el catálogo confirmado aquí viaja al inquilino. En Local/SQLite o en VPS la
// empresa nace en el escritorio del cliente, y el catálogo se trae desde allí (Contabilidad →
// Traer mis datos → Plan de cuentas).
//
// Antes el Editor exigía contestarla y subir el archivo SIEMPRE, también en local/vps: el asesor
// tenía que conseguir un archivo que nadie iba a leer, y la cotización ya creada enseñaba como
// pendiente un freno que no existe. Vive aquí, sin React, para poder probarlo con `node --test`.

/** La única modalidad en la que el catálogo del contador se entrega desde la cotización. */
export function modalidadEntregaCatalogo(modalidad) {
  return modalidad === 'nube'
}

/**
 * Lo que impide crear el borrador por el lado del catálogo, o '' si nada lo impide.
 * Fuera de la nube no se exige nada: el catálogo no se entrega desde aquí.
 */
export function frenoCatalogoEnCreacion({ modalidad, declaracion }) {
  if (!modalidadEntregaCatalogo(modalidad)) return ''
  if (!declaracion) return 'Falta contestar si el cliente trae el catálogo de su contador.'
  if (declaracion.propio && !declaracion.archivo) return 'Falta elegir el archivo del catálogo de su contador.'
  return ''
}

/**
 * La declaración que se manda con el primer guardado, o null si no se manda ninguna.
 * Fuera de la nube no se envía aunque el estado la conserve (se contestó con «Nube» elegida y
 * luego se cambió la modalidad): sería subir un archivo a una cotización que no lo usa.
 */
export function declaracionAEnviar({ modalidad, declaracion }) {
  return modalidadEntregaCatalogo(modalidad) && declaracion ? declaracion : null
}

/**
 * Estado del freno del catálogo en una cotización ya creada (el aviso junto a «Crear empresa
 * demo»). Fuera de la nube no frena: no hay empresa demo que crear y el api no lo exige.
 */
export function estadoFrenoCatalogo({ modalidad, estado }) {
  if (!modalidadEntregaCatalogo(modalidad)) return { sinDeclarar: false, frena: false }
  const sinDeclarar = estado?.origen === 'sin_declarar'
  const frena = sinDeclarar || Boolean(estado?.propio && !estado?.listo)
  return { sinDeclarar, frena }
}
